module.exports = __webpack_public_path__ + "static/media/shopping.57a195b4.svg";